import { render, staticRenderFns } from "./buy-huay.vue?vue&type=template&id=038e76f8&scoped=true&"
import script from "./buy-huay.vue?vue&type=script&lang=js&"
export * from "./buy-huay.vue?vue&type=script&lang=js&"
import style0 from "./buy-huay.vue?vue&type=style&index=0&id=038e76f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e76f8",
  null
  
)

export default component.exports